import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import makeStyles from "@mui/styles/makeStyles";
import SectionHeader from "../section-header/SectionHeader";
import CarouselComponent from "../carousel-component/CarouselComponent";
export const generalSubHeaderStyles = theme => ({
  generalSubHeaderContent: {
    paddingLeft: 0,
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 83
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: 90
    }
  }
});
const useStyles = makeStyles(theme => ({
  ...generalSubHeaderStyles(theme),
  subHeaderContent: {
    textAlign: "center",
    width: "100%"
  },
  gridContent: {
    marginTop: 30,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "nowrap"
  },
  gridItem: {
    display: "none"
  },
  paperContainer: {
    display: "grid",
    alignItems: "center",
    width: "calc(100% - 130px)",
    justifyContent: "center",
    borderRadius: 12,
    padding: "32px 16px",
    height: 300,
    textAlign: "center"
  },
  carouselItem: {
    display: "flex"
  },
  paperText: {
    wordWrap: "break-word",
    overflow: "hidden"
  },
  [theme.breakpoints.up("sm")]: {
    subHeaderContent: {
      width: "90%",
      textAlign: "left"
    },
    paperContainer: {
      width: "100%"
    },
    gridItem: {
      display: "flex"
    },
    carouselItem: {
      display: "none"
    }
  },
  [theme.breakpoints.up("md")]: {
    subHeaderContent: {
      width: "70%"
    },
    paperContainer: {
      height: 170
    }
  },
  [theme.breakpoints.up("lg")]: {
    subHeaderContent: {
      width: "60%"
    }
  }
}));
const ExampleQuestions = ({
  content,
  leftSpaceContainer,
  extraHeaderStyle = "",
  bottomSpaceContainer = "",
  subHeaderContainer
}) => {
  const classes = useStyles();
  const itemComponent = textContent => {
    return /*#__PURE__*/React.createElement(Paper, {
      elevation: extraHeaderStyle === "" ? 0 : 1,
      className: classes.paperContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textPrimary",
      className: classes.paperText
    }, textContent));
  };
  return /*#__PURE__*/React.createElement(Grid, {
    className: `${leftSpaceContainer} ${bottomSpaceContainer}`
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header,
    extraHeaderStyle: extraHeaderStyle
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary",
    className: `${classes.subHeaderContent} ${subHeaderContainer ? subHeaderContainer : classes.generalSubHeaderContent}`
  }, content.subHeader), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.gridContent
  }, content.questions.map((item, index) => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    className: classes.gridItem,
    key: index
  }, itemComponent(item.text)))), /*#__PURE__*/React.createElement(CarouselComponent, {
    contentComponent: itemText => itemComponent(itemText),
    contentArr: content.questions,
    contentStyles: classes.carouselItem
  }));
};
ExampleQuestions.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  extraHeaderStyle: PropTypes.string,
  bottomSpaceContainer: PropTypes.string,
  subHeaderContainer: PropTypes.string
};
export default ExampleQuestions;